"use strict";

var _ = require('underscore');
var SoaCollection = require('bunsen/collections/SoaCollection');
var Offer = require('bunsen/models/ecomm/Offer');
var endpoints = require('dibs-endpoints');
var moment = require('moment');
var root = typeof window === 'undefined' ? global : window;

root.bunsen = root.bunsen || {};

/**
 * @mixes bunsen.SoaCollection
 * @class
 * @property {bunsen.Offer} model - {@link bunsen.Offer}
 * @property {bunsen.endpoints.offers} url -
 */
module.exports = root.bunsen.Offers = SoaCollection.extend({
    url: endpoints,
    model: Offer,
    comparator: function (offer) {
        return parseInt(moment(offer.get("createdDate")).format("X"), 10) || -1;
    },
    // Use getters in case this changes
    getMostRecent: function () {
        return this.last();
    },
    getMostRecentBuyerOffer: function () {
        return _.find(this.toArray().reverse(), function (o) {
            return o.isBuyerInitiatedOffer();
        });
    },
    getMostRecentDealerOffer: function () {
        return _.find(this.toArray().reverse(), function (o) {
            return o.isDealerInitiatedOffer();
        });
    },
    getFirst: function () {
        return this.first();
    }

});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/ecomm/Offers.js
// module id = 161
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56